import * as React from "react";
const Users = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.014 1.081c.23-.08.474-.103.714-.067l.104.02.103.026c.203.06.391.165.552.304l.078.072.072.077c.139.16.242.349.303.552l.027.103.02.105c.035.239.01.483-.069.712h.001l-6.5 19v.002a1.5 1.5 0 0 1-2.764.176l-.047-.105-3.18-7.93-.042-.092a1 1 0 0 0-.514-.463v-.001l-7.93-3.18a1.5 1.5 0 0 1-.94-1.43l.006-.115a1.5 1.5 0 0 1 .283-.734l.07-.09a1.5 1.5 0 0 1 .653-.442zM3.936 9.037l6.679 2.678a3 3 0 0 1 1.609 1.527l.06.138v.002l2.678 6.68 5.735-16.759z"
    />
    <path
      fill="currentColor"
      d="M21.147 1.44a1 1 0 0 1 1.414 1.414l-10.94 10.94-.076.068a1 1 0 0 1-1.338-1.484z"
    />
  </svg>
);
export default Users;
